"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var context_1 = require("App/context");
var _ = __importStar(require("lodash"));
var compatible_1 = require("@ant-design/compatible");
var antd_1 = require("antd");
var react_redux_1 = require("react-redux");
var BreadcrumbItem = function (_a) {
    var _b;
    var page = _a.page;
    var breadcrumb = react_redux_1.useSelector(function (state) { return state.breadcrumb; });
    var getPageTitle = function () {
        if (page.breadcrumbProps) {
            if (page.breadcrumbProps.lookupKey) {
                if (breadcrumb.map.has(page.breadcrumbProps.lookupKey)) {
                    return breadcrumb.map.get(page.breadcrumbProps.lookupKey);
                }
            }
            return page.breadcrumbProps.title;
        }
        if (page.navProps) {
            return page.navProps.title;
        }
        return '...';
    };
    var pageTitle = getPageTitle();
    return ((_b = page.navProps) === null || _b === void 0 ? void 0 : _b.icon) ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(compatible_1.Icon, { type: page.navProps.icon, style: { marginRight: 10 } }),
        react_1.default.createElement("span", null, pageTitle))) : (react_1.default.createElement(react_1.default.Fragment, null, pageTitle));
};
var BreadcrumbRoute = function () {
    var location = react_router_dom_1.useLocation();
    var ctx = react_1.useContext(context_1.ApplicationContext);
    var _a = react_1.useState([]), items = _a[0], setItems = _a[1];
    var pushPage = function (breadcrumbPath, page, rootPage) {
        var _a;
        var copy = __assign(__assign({}, page), { routeProps: __assign(__assign({}, page.routeProps), { path: rootPage
                    ? "" + rootPage.routeProps.path + page.routeProps.path
                    : page.routeProps.path }) });
        // console.log('pushPage', copy);
        if (copy.breadcrumbProps || copy.navProps) {
            breadcrumbPath.push(copy);
        }
        if (copy.routeProps.path !== location.pathname && ((_a = copy.children) === null || _a === void 0 ? void 0 : _a.length)) {
            // eslint-disable-next-line no-use-before-define
            breadcrumbPath.push.apply(breadcrumbPath, getBreadcrumbPath(copy));
        }
        return breadcrumbPath;
    };
    var getBreadcrumbPath = function (rootPage) {
        var _a;
        var breadcrumbPath = [];
        if (rootPage) {
            // console.log('getBreadcrumbPath with rootPage', rootPage);
            var locationParts_1 = location.pathname.split('/');
            // console.log('--> location.parts', locationParts);
            (_a = rootPage.children) === null || _a === void 0 ? void 0 : _a.find(function (p) {
                var _a, _b;
                var childPathname = "" + rootPage.routeProps.path + p.routeProps.path;
                var childLocationParts = childPathname.split('/');
                // console.log('--> checking child', childPathname, childLocationParts);
                if (locationParts_1.length >= childLocationParts.length) {
                    var childLocationPartsIndex = childLocationParts.length - 1;
                    // console.log('--> potential match?', childLocationParts[childLocationPartsIndex], locationParts[childLocationPartsIndex]);
                    if (childLocationParts[childLocationPartsIndex] === locationParts_1[childLocationPartsIndex]) {
                        breadcrumbPath = pushPage(breadcrumbPath, p, rootPage);
                        return true;
                    }
                    if (childLocationParts[childLocationPartsIndex].startsWith(':')) {
                        var pageCopy = _.cloneDeep(p);
                        pageCopy.breadcrumbProps = {
                            title: ((_a = pageCopy.breadcrumbProps) === null || _a === void 0 ? void 0 : _a.title) || '',
                            component: ((_b = pageCopy.breadcrumbProps) === null || _b === void 0 ? void 0 : _b.component) || undefined,
                            lookupKey: locationParts_1.slice(0, childLocationParts.length).join('/'),
                        };
                        breadcrumbPath = pushPage(breadcrumbPath, pageCopy, rootPage);
                        return true;
                    }
                }
                return false;
            });
        }
        else {
            // console.log('getBreadcrumbPath without rootPage');
            var pages = ctx.pages.slice(); // create a copy of pages
            var foundRoot = pages.find(function (p) { return location.pathname.startsWith(p.routeProps.path); });
            if (foundRoot) {
                breadcrumbPath = pushPage(breadcrumbPath, foundRoot);
            }
        }
        return breadcrumbPath;
    };
    react_1.useEffect(function () {
        // console.log('pathname or breadcrumb map changed', location.pathname, ctx.breadcrumbMap);
        setItems(getBreadcrumbPath());
    }, [location.pathname]);
    // console.log('breadcrumbRoute render', ctx.breadcrumbMap);
    return items.length ? (react_1.default.createElement(antd_1.Breadcrumb, null, items.map(function (page, index) {
        var _a, _b, _c, _d;
        if (index !== items.length - 1) {
            if (((_a = page.breadcrumbProps) === null || _a === void 0 ? void 0 : _a.component) != undefined) {
                var breadcrumbItemProps = {
                    active: false,
                    page: page
                };
                return react_1.default.createElement((_b = page.breadcrumbProps) === null || _b === void 0 ? void 0 : _b.component, breadcrumbItemProps);
            }
            return (react_1.default.createElement(antd_1.Breadcrumb.Item, { key: "breadcrumb-" + page.name },
                react_1.default.createElement(react_router_dom_1.Link, { to: page.routeProps.path },
                    react_1.default.createElement(BreadcrumbItem, { page: page }))));
        }
        if (((_c = page.breadcrumbProps) === null || _c === void 0 ? void 0 : _c.component) != undefined) {
            var breadcrumbItemProps = {
                active: true,
                page: page
            };
            return react_1.default.createElement((_d = page.breadcrumbProps) === null || _d === void 0 ? void 0 : _d.component, breadcrumbItemProps);
        }
        return (react_1.default.createElement(antd_1.Breadcrumb.Item, { key: "breadcrumb-" + page.name },
            react_1.default.createElement(BreadcrumbItem, { page: page })));
    }))) : null;
};
exports.default = BreadcrumbRoute;
//# sourceMappingURL=index.js.map